const toQty = (item) => Number(item?.quantity) || 1;

export const getOrderItemUnitPrice = (item) => {
  const price = Number(item?.price);
  return Number.isNaN(price) ? 0 : price;
};

export const getOrderItemMrp = (item) => {
  const mrp = Number(item?.mrp);
  if (Number.isNaN(mrp) || mrp <= 0) return null;
  return mrp;
};

export const itemShowsMrpStrike = (item) => {
  const mrp = getOrderItemMrp(item);
  const price = getOrderItemUnitPrice(item);
  return mrp != null && mrp > price;
};

export const sumLineSubtotal = (items = []) =>
  items.reduce((sum, item) => sum + getOrderItemUnitPrice(item) * toQty(item), 0);

export const sumMrpTotal = (items = []) =>
  items.reduce((sum, item) => {
    const mrp = getOrderItemMrp(item);
    const unit = mrp != null ? mrp : getOrderItemUnitPrice(item);
    return sum + unit * toQty(item);
  }, 0);

export const orderHasMrpPricing = (items = []) =>
  items.some((item) => getOrderItemMrp(item) != null);

export const orderShowsMrpTotalRow = (items = []) =>
  items.some((item) => itemShowsMrpStrike(item));

/**
 * Build order summary rows for admin order detail (defensive for legacy orders).
 */
export const computeOrderSummaryDisplay = (order = {}) => {
  const items = order.items || [];
  const lineSubtotal = sumLineSubtotal(items);
  const mrpTotal = sumMrpTotal(items);
  const showMrpRow = orderShowsMrpTotalRow(items);

  const subtotalLabel = showMrpRow ? 'MRP total' : 'Subtotal';
  const subtotalAmount = showMrpRow
    ? mrpTotal
    : Number(order.subtotal) || lineSubtotal;

  const catalogDiscount = showMrpRow ? Math.max(0, mrpTotal - lineSubtotal) : 0;

  const orderLevelDiscount =
    Number(order.totalDiscount ?? order.discountAmount ?? 0) || 0;
  const couponFromField = Number(order.couponDiscount ?? 0) || 0;
  const isCouponType = order.appliedDiscountType === 'coupon';
  const couponDiscount =
    couponFromField > 0
      ? couponFromField
      : isCouponType && orderLevelDiscount > 0
        ? orderLevelDiscount
        : 0;

  const nonCouponOrderDiscount =
    isCouponType && couponDiscount > 0 ? 0 : orderLevelDiscount;

  let discountAmount = nonCouponOrderDiscount > 0 ? nonCouponOrderDiscount : catalogDiscount;

  if (couponDiscount > 0 && discountAmount > 0 && discountAmount === couponDiscount) {
    discountAmount = 0;
  }

  const shippingFee = Number(order.shippingFee) || 0;
  const total = Number(order.total ?? order.amount ?? 0);

  return {
    subtotalLabel,
    subtotalAmount,
    discountAmount,
    couponDiscount,
    shippingFee,
    total,
    showMrpRow,
  };
};
